<template>
    <div>
        <div id="__next">
            <div class="Page__Inner-sc-14vv5uc-0 hLJFPF">
                <header class="header_wrap" v-bind:class="{ 'fixed': fixedTop(), 'is_scrolled': fixedTop() }">
                    <div class="nav_wrap">
                        <router-link class="logo" to="/">
                            <svg viewBox="0 0 530 82" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd"
                                clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
                                <path
                                    d="M503.519 35.888h-51.432V11.46c0-3.107 0-6.213 10.875-7.912v-1.83h-36.488v1.83c10.874 1.699 10.874 4.805 10.874 7.912v56.427c0 3.106 0 7.056-10.874 7.912v1.829h36.488v-1.83c-10.875-.855-10.875-4.805-10.875-7.911V40.094h51.432v27.792c0 3.106 0 7.056-10.875 7.912v1.829h36.488v-1.83c-10.874-.855-10.874-4.805-10.874-7.911V11.459c0-3.107 0-6.213 10.874-7.912v-1.83h-36.488v1.83c10.875 1.699 10.875 4.805 10.875 7.912v24.43zM399.167 4.795c3.787 1.221 7.55 2.512 12.301-.008.174 7.344.35 14.688.526 22.032h-1.534c-5.008-8.235-9.168-15.395-18.293-19.896-9.13-4.501-23.224-6.341-33.555-.912-10.325 5.43-16.885 18.125-18.221 29.55-1.336 11.429 2.554 21.58 7.728 28.562 5.168 6.981 11.621 10.79 19.688 12.272 8.066 1.485 17.747.645 25.08-3.293 7.333-3.942 12.32-10.982 17.541-20.31h1.566l-.464 23.275h-2.131c-3.197-4.395-5.376-2.92-7.685-1.688-10.835 5.781-27.251 7.701-41.038 5.33-13.784-2.367-24.939-9.023-31.573-18.213-6.632-9.186-8.744-20.904-5.998-31.037 2.747-10.136 10.355-18.683 20.072-23.813 9.72-5.128 21.552-6.835 31.227-6.63 9.675.21 17.192 2.336 24.763 4.779zm-321.934.39c3.784 1.22 7.55 2.514 12.299-.009l.528 22.032h-1.534c-5.01-8.234-9.168-15.394-18.296-19.896C61.102 2.811 47.006.971 36.678 6.4 26.35 11.83 19.79 24.526 18.454 35.952c-1.333 11.427 2.558 21.582 7.728 28.563 5.174 6.981 11.624 10.79 19.688 12.27 8.067 1.485 17.747.645 25.08-3.294 7.336-3.941 12.32-10.981 17.544-20.31h1.566l-.464 23.275h-2.134c-3.194-4.394-5.376-2.92-7.682-1.688C68.945 80.55 52.526 82.47 38.742 80.1c-13.786-2.368-24.938-9.024-31.57-18.213-6.635-9.187-8.747-20.904-6-31.04 2.746-10.134 10.352-18.68 20.072-23.811C30.964 1.907 42.796.198 52.47.408c9.675.208 17.192 2.334 24.763 4.776zM186.9 1.717l-28.856 58.154c-9.272-19.386-18.547-38.77-27.819-58.154h-27.11v1.861a18.21 18.21 0 016.086 1.483c1.923.84 3.437 2.138 4.541 3.888.795 1.274 1.304 3.29 1.526 6.05.133 1.534.2 3.158.2 4.872v39.6c0 3.806-.256 6.632-.763 8.483-.51 1.848-1.448 3.37-2.819 4.565a11.485 11.485 0 01-4.21 2.352c-1.57.486-3.088.784-4.56.896v1.859h28.856v-1.859c-1.477-.112-3.003-.41-4.579-.896a11.54 11.54 0 01-4.23-2.352c-1.37-1.194-2.311-2.706-2.823-4.538-.51-1.83-.765-4.667-.765-8.51V14.526c10.792 21.034 21.586 42.066 32.38 63.101h1.39c11.422-22.461 22.843-44.923 34.262-67.384v49.23c0 3.805-.256 6.631-.768 8.482-.512 1.848-1.451 3.37-2.822 4.565a12.348 12.348 0 01-4.23 2.326c-1.575.504-3.124.81-4.642.922v1.859H213.9v-1.859c-11.592-.685-11.592-8.485-11.592-16.285v-39.61c0-7.803 0-15.603 11.592-16.294V1.718h-27zm40.208 1.829c11.605 1.699 11.605 4.805 11.605 7.912v56.427c0 3.106 0 7.056-11.605 7.912v1.829h76.283l7.336-21.837h-2.52c-16.659 18.493-22.91 18.493-29.163 18.493h-8.099c-16.501-.856-16.501-4.805-16.501-7.912V37.352h16.552c5.459 0 10.915 0 19.003 6.731V28.096c-8.088 6.734-13.544 6.734-19.003 6.734h-16.552V5.083h20.261c7.424 0 14.846 0 26.326 11.64V1.718h-73.923v1.829">
                                </path>
                            </svg>
                        </router-link>
                        <nav class="main" v-bind:class="{ 'is_active': mobileMenu }">
                            <ul class="menu">
                                <li class="has_children" v-bind:class="{ 'is_active': menu1 }">
                                    <a>
                                        Giới thiệu<i v-on:click="menu1 = !menu1" class="far fa-angle-down"></i>
                                    </a>
                                    <ul class="submenu">
                                        <li>
                                            <router-link to="/about/company">Công ty</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/projects">
                                                Dự án công trình</router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li class="has_children" v-bind:class="{ 'is_active': menu2 }">
                                    <router-link to="/product/window-hardware">
                                        Phụ kiện cửa sổ <i v-on:click="menu2 = !menu2" class="far fa-angle-down"></i>
                                    </router-link>
                                    <ul class="submenu">
                                        <li>
                                            <router-link to="/product/window/out-swing-casement">
                                                Cửa sổ mở ra ngoài</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/window/l-series">Cửa sổ mở ra ngoài tích hợp
                                                lưới</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/window/awning-outswing">
                                                Cửa sổ treo ngoài</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/window/concealed-hinge-configuration">
                                                Cửa sổ mở trong lật</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/window/in-swing-casement">
                                                Cửa sổ mở trong</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/window/sliding">
                                                Cửa sổ trượt</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/handle-series/venice-series">
                                                Tay nắm</router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li class="has_children" v-bind:class="{ 'is_active': menu3 }">
                                    <router-link to="/product/door-hardware">
                                        Phụ kiện cửa<i v-on:click="menu3 = !menu3" class="far fa-angle-down"></i>
                                    </router-link>
                                    <ul class="submenu">
                                        <li>
                                            <router-link to="/product/door/convention-configuration">
                                                Cửa lùa nâng trượt</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/door/gliding">
                                                Cửa lùa</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/door/even-configuration">
                                                Cửa gấp</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/door/hinged">
                                                Cửa mở quay</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product/handle-series/venice-series">
                                                Tay nắm</router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li class="has_children" v-bind:class="{ 'is_active': menu4 }">
                                    <a>
                                        Hệ thống<i v-on:click="menu4 = !menu4" class="far fa-angle-down"></i>
                                    </a>
                                    <ul class="submenu ">
                                        <li>
                                            <router-link to="/product/solutions/gliding-window-system">
                                                Hệ thống cựa sổ trượt</router-link>
                                        </li>
                                        <li>
                                            <router-link
                                                to="/product/solutions/outswing-casement-window-built-in-system">
                                                Hệ thống cửa sổ mở ra ngoài khung viền hẹp tích hợp</router-link>
                                        </li>
                                        <li>
                                            <router-link
                                                to="/product/solutions/tightly-sealed-sliding-window-hardware-systems">
                                                Hệ thống cựa sổ trượt kín</router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <router-link to="/blog">
                                        Tin tức</router-link>
                                </li>
                                <li>
                                    <router-link to="/contact">
                                        Liên hệ</router-link>
                                </li>
                            </ul>
                        </nav>
                        <button type="button" class="menu_toggle" v-on:click="mobileMenu = !mobileMenu">
                            <svg height="384pt" viewBox="0 -53 384 384" width="384pt"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0">
                                </path>
                                <path
                                    d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0">
                                </path>
                                <path
                                    d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0">
                                </path>
                            </svg>
                        </button>
                    </div>
                </header>

                <slot></slot>
                <div class="LearnHow__LearnHowWrap-bgqo87-0 hWBHX fade_in">
                    <div class="animated fadeInUp" style="animation-duration: 1s;">
                        <div class="container_small">
                            <div class="learn_how_grid_wrapper">
                                <div class="learn_how_grid">
                                    <div class="learn_how_text">
                                        <h2 class="section_title">
                                            <svg viewBox="0 0 530 82" xmlns="http://www.w3.org/2000/svg"
                                                fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round"
                                                stroke-miterlimit="2">
                                                <path
                                                    d="M503.519 35.888h-51.432V11.46c0-3.107 0-6.213 10.875-7.912v-1.83h-36.488v1.83c10.874 1.699 10.874 4.805 10.874 7.912v56.427c0 3.106 0 7.056-10.874 7.912v1.829h36.488v-1.83c-10.875-.855-10.875-4.805-10.875-7.911V40.094h51.432v27.792c0 3.106 0 7.056-10.875 7.912v1.829h36.488v-1.83c-10.874-.855-10.874-4.805-10.874-7.911V11.459c0-3.107 0-6.213 10.874-7.912v-1.83h-36.488v1.83c10.875 1.699 10.875 4.805 10.875 7.912v24.43zM399.167 4.795c3.787 1.221 7.55 2.512 12.301-.008.174 7.344.35 14.688.526 22.032h-1.534c-5.008-8.235-9.168-15.395-18.293-19.896-9.13-4.501-23.224-6.341-33.555-.912-10.325 5.43-16.885 18.125-18.221 29.55-1.336 11.429 2.554 21.58 7.728 28.562 5.168 6.981 11.621 10.79 19.688 12.272 8.066 1.485 17.747.645 25.08-3.293 7.333-3.942 12.32-10.982 17.541-20.31h1.566l-.464 23.275h-2.131c-3.197-4.395-5.376-2.92-7.685-1.688-10.835 5.781-27.251 7.701-41.038 5.33-13.784-2.367-24.939-9.023-31.573-18.213-6.632-9.186-8.744-20.904-5.998-31.037 2.747-10.136 10.355-18.683 20.072-23.813 9.72-5.128 21.552-6.835 31.227-6.63 9.675.21 17.192 2.336 24.763 4.779zm-321.934.39c3.784 1.22 7.55 2.514 12.299-.009l.528 22.032h-1.534c-5.01-8.234-9.168-15.394-18.296-19.896C61.102 2.811 47.006.971 36.678 6.4 26.35 11.83 19.79 24.526 18.454 35.952c-1.333 11.427 2.558 21.582 7.728 28.563 5.174 6.981 11.624 10.79 19.688 12.27 8.067 1.485 17.747.645 25.08-3.294 7.336-3.941 12.32-10.981 17.544-20.31h1.566l-.464 23.275h-2.134c-3.194-4.394-5.376-2.92-7.682-1.688C68.945 80.55 52.526 82.47 38.742 80.1c-13.786-2.368-24.938-9.024-31.57-18.213-6.635-9.187-8.747-20.904-6-31.04 2.746-10.134 10.352-18.68 20.072-23.811C30.964 1.907 42.796.198 52.47.408c9.675.208 17.192 2.334 24.763 4.776zM186.9 1.717l-28.856 58.154c-9.272-19.386-18.547-38.77-27.819-58.154h-27.11v1.861a18.21 18.21 0 016.086 1.483c1.923.84 3.437 2.138 4.541 3.888.795 1.274 1.304 3.29 1.526 6.05.133 1.534.2 3.158.2 4.872v39.6c0 3.806-.256 6.632-.763 8.483-.51 1.848-1.448 3.37-2.819 4.565a11.485 11.485 0 01-4.21 2.352c-1.57.486-3.088.784-4.56.896v1.859h28.856v-1.859c-1.477-.112-3.003-.41-4.579-.896a11.54 11.54 0 01-4.23-2.352c-1.37-1.194-2.311-2.706-2.823-4.538-.51-1.83-.765-4.667-.765-8.51V14.526c10.792 21.034 21.586 42.066 32.38 63.101h1.39c11.422-22.461 22.843-44.923 34.262-67.384v49.23c0 3.805-.256 6.631-.768 8.482-.512 1.848-1.451 3.37-2.822 4.565a12.348 12.348 0 01-4.23 2.326c-1.575.504-3.124.81-4.642.922v1.859H213.9v-1.859c-11.592-.685-11.592-8.485-11.592-16.285v-39.61c0-7.803 0-15.603 11.592-16.294V1.718h-27zm40.208 1.829c11.605 1.699 11.605 4.805 11.605 7.912v56.427c0 3.106 0 7.056-11.605 7.912v1.829h76.283l7.336-21.837h-2.52c-16.659 18.493-22.91 18.493-29.163 18.493h-8.099c-16.501-.856-16.501-4.805-16.501-7.912V37.352h16.552c5.459 0 10.915 0 19.003 6.731V28.096c-8.088 6.734-13.544 6.734-19.003 6.734h-16.552V5.083h20.261c7.424 0 14.846 0 26.326 11.64V1.718h-73.923v1.829">
                                                </path>
                                            </svg>
                                        </h2>
                                        <div class=" content_wrap">
                                            <div class="section_description content">
                                                <p>
                                                    CMECH được xây dựng dựa trên nguyên tắc hợp tác và dịch vụ, cung cấp
                                                    vật liệu xuất sắc, thiết
                                                    kế sáng tạo, công nghệ thông minh và đảm bảo chất lượng. Nếu có bất
                                                    kỳ câu hỏi nào, vui lòng
                                                    liên hệ với chúng tôi. Đội ngũ của chúng tôi sẽ liên hệ với bạn
                                                    trong vòng 24 giờ.</p>
                                            </div>
                                        </div>
                                        <div class="button_wrapper">
                                            <div class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper">
                                                <router-link to="/contact">
                                                    Liên hệ chúng tôi</router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="learn_how_image">
                                        <img src="/uploads/cmech_why_512f70e94c.jpg" alt="learn how" loading="lazy">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer_wrap">
                <div class="container_small">
                    <div class="footer_grid_wrapper">
                        <div class="footer_grid">
                            <div class="grid_content">
                                <h4>
                                    Trưng bày sản phẩm</h4>
                                <ul>
                                    <li>
                                        <router-link to="/product/window/out-swing-casement">
                                            Phụ kiện cửa sổ</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/product/door/hinged">
                                            Phụ kiện cửa</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/product/handle-series">
                                            Tay nắm</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/product/solutions/narrow-edge-built-in-external-opening">
                                            Hệ thống</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="grid_content">
                                <h4>
                                    Cmech</h4>
                                <ul>
                                    <li>
                                        <router-link to="/about/company">
                                            Câu chuyện của chúng tôi</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/projects">
                                            Dự án công trình</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/blog">
                                            Tin tức mới nhất</router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="grid_content">
                                <h4>Liên hệ</h4>
                                <ul>
                                    <li>
                                        <a href="tel:0949414368" target="_blank"><i class="fas fa-phone"></i>
                                            0949414368</a>
                                    </li>
                                    <li><a href="mailto:cmechvietnam.com@gmail.com" target="_blank"><i
                                                class="far fa-envelope"></i>
                                            Cmechvietnam.com@gmail.com</a></li>
                                    <li><a href="https://www.google.com/maps?q=10.8646389,106.6573484&z=14&t=m&mapclient=embed"
                                            target="_blank">Địa
                                            chỉ: M14 Nguyễn Trường Tộ, Khu phố 1, phường Thới An, Quận
                                            12, TP.Hồ Chí Minh</a></li>
                                </ul>
                            </div>
                            <div class="grid_content">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3918.301741805047!2d106.65477347504309!3d10.864638889289557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTDCsDUxJzUyLjciTiAxMDbCsDM5JzI2LjUiRQ!5e0!3m2!1svi!2s!4v1734890944766!5m2!1svi!2s"
                                    width="300" height="225" style="border:0;" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="footer_copyrights">
                        <p>
                            ©2024 Cmech - Bảo lưu mọi quyền</p>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
let scrollHandle;
export default {
    props: ["transparent"],
    data() {
        return {
            scrollY: 0,
            mobileMenu: false,
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
        }
    },
    mounted() {
        const t = this;
        scrollHandle = function () {
            t.scrollY = window.scrollY;
        }
        window.addEventListener("scroll", scrollHandle);
    },
    unmounted() {
        window.removeEventListener("scroll", scrollHandle);
    },
    methods: {
        fixedTop() {
            return this.transparent ? this.scrollY > 200 : true;
        }
    }
}
</script>
<style lang="less">
body {
    text-align: left;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    text-align: left;
}

li {
    text-align: left;
}
</style>